import CookieBanner from './CookieBanner';

export { CookieBanner };
export default CookieBanner;
